import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import Divider from "@mui/material/Divider";
import Services_img from "../../assets/statistics.png";
import { useDispatch, useSelector } from "react-redux";
import ButtonSys from "../../common/ButtonSys";
import { t } from "../../utils/i18n";
import { openContactModal } from "../../store/modalSlice";
import { ThemeContext } from "../../ThemeContext";

const Services = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const { mode } = useContext(ThemeContext)
  const { data, status } = useSelector((state) => state.productData.statistics);

  const dispatch = useDispatch();
  const handleOpenModal = () => {
    dispatch(openContactModal(t(lang, "contact.request_offer")));
  };

  if (!Array.isArray(data) || data.length === 0) {
    return null; 
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 0,
        padding: "30px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "95%",
          borderRadius: "20px",
          backgroundColor: (theme) => theme.palette.background.statistics,
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
          p: 15,
          py: 10,
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        {/* Background image with reduced opacity */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${Services_img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: mode === "light" ? 1 : 0.5,
            zIndex: 1,
          }}
        />

        {/* Background pattern */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 3,
            textAlign: "center",
            p: "40px 0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            {data.map((data_static) => (
              <Box>
                <Typography
                  variant="h4"
                  component="h2"
                  fontWeight="300"
                  sx={{
                    fontSize: "2.5rem",
                    mb: 1,
                    color: "#dd3740",
                  }}
                >
                  {data_static.subtitle}
                </Typography>
                <Typography
                  variant="h2"
                  fontWeight="200"
                  sx={{
                    mb: 1,
                    color: (theme) => theme.palette.text.primary,
                  }}
                >
                  {lang === "ar" ? data_static.title_ar : data_static.title}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              mt: 10,
            }}
          >
            <ButtonSys
              onClick={handleOpenModal}
              text={t(lang, "services.buttonTitle")}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Services;
